import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { Chip } from '../ui/Chip';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';

const SKILL_SUGGEST = ['React', 'TypeScript', 'Node.js', 'Figma', 'UI Design', 'Copy', 'SEO', 'AWS', 'PostgreSQL', 'Next.js'];

export function NewVendorModal({ onClose }: { onClose: () => void }) {
  const qc = useQueryClient();
  const [form, setForm] = useState({
    fullName: '', vat: '', email: '', phone: '', city: '',
    hourlyRate: '' as number | string,
    notes: '', skills: [] as string[],
    active: true,
  });

  const toggleSkill = (s: string) => setForm({ ...form, skills: form.skills.includes(s) ? form.skills.filter((x) => x !== s) : [...form.skills, s] });

  const create = useMutation({
    mutationFn: () => api.post('/suppliers', { ...form, hourlyRate: form.hourlyRate ? Number(form.hourlyRate) : null }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['suppliers'] });
      toast.ok('Professionista creato', form.fullName);
      onClose();
    },
    onError: (err) => toast.alert('Errore creazione professionista', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title="Nuovo professionista"
      kicker="Risorse · Network esterno"
      onClose={onClose}
      size="lg"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => create.mutate()} disabled={!form.fullName || create.isPending}>
            Aggiungi <Icon name="arrowRight" size={12} />
          </button>
        </>
      }
    >
      <div className="form-section">
        <div className="form-section-hd">Anagrafica</div>
        <div className="form-grid">
          <Field label="Nome e cognome" required span={8}>
            <input className="inp" value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} />
          </Field>
          <Field label="Città" span={4}>
            <input className="inp" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
          </Field>
          <Field label="P.IVA" span={6}>
            <input className="inp mono" value={form.vat} onChange={(e) => setForm({ ...form, vat: e.target.value })} />
          </Field>
          <Field label="Email" span={6}>
            <input className="inp" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </Field>
          <Field label="Telefono" span={6}>
            <input className="inp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </Field>
          <Field label="Tariffa (€/h)" span={6}>
            <input className="inp mono" type="number" value={form.hourlyRate} onChange={(e) => setForm({ ...form, hourlyRate: e.target.value })} />
          </Field>
        </div>
      </div>

      <div className="form-section">
        <div className="form-section-hd">Competenze</div>
        <div className="chip-picker mb-2">
          {SKILL_SUGGEST.map((s) => (
            <Chip key={s} tone={form.skills.includes(s) ? 'active' : 'ghost'} onClick={() => toggleSkill(s)}>
              {form.skills.includes(s) && <Icon name="check" size={10} />} {s}
            </Chip>
          ))}
        </div>
        <div className="field-hint">Aggiungi anche altre skill personalizzate dalla scheda dettaglio.</div>
      </div>

      <div className="form-section">
        <Field label="Note">
          <textarea className="inp" rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
        </Field>
      </div>
    </Modal>
  );
}
